import React from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";

import { Row, Col, Button } from "reactstrap";
import { Block, BlockHead, BlockHeadContent, BlockTitle, BlockDes, BackTo } from "../../../components/block/Block";
import { PreviewCard } from "../../../components/preview/Preview";
import { OverlineTitle } from "../../../components/text/Text";

const AddUser = ({ ...props }) => {
    const ChangePage = (num, vnum, name) => {
        sessionStorage.setItem('catid', num);
        sessionStorage.setItem('value', vnum);
        sessionStorage.setItem('dropdownname', name);
        props.history.push("/Add-Detail")
    }



    return (
        <React.Fragment>
            <Head title="Drop-Down" />
            <Content page="component">
                <BlockHead size="lg" wide="sm">
                    <BlockHeadContent>

                        <BlockTitle tag="h2" className="fw-normal">
                            Edit DropDown Data
                        </BlockTitle>
                        <BlockDes>
                            <p className="lead">
                                Click On a particular Option to edit their DropDown Data. All the Changes made will be
                                reflated in the live server Immediately
                            </p>
                        </BlockDes>
                    </BlockHeadContent>
                </BlockHead>

                <Block size="lg">
                    <BlockHead>

                    </BlockHead>
                    <PreviewCard>
                        <Row className="g-4">
                            
                            <Col xs="6" md="3">
                                <OverlineTitle tag="span" className="preview-title">
                                    State Status
                                </OverlineTitle>
                                <Button color="secondary" onClick={() => ChangePage('43', 'null', "EEX State")}>State Status</Button>
                            </Col>
                     




                        </Row>
                    </PreviewCard>


                </Block>
            </Content>
        </React.Fragment>
    );
};

export default AddUser;
